import React from 'react'
import PropTypes from 'prop-types';
import compose from 'lodash.compose';
import { translate } from 'react-i18next';
import Link from '../../link';
import Logo from '../../logo';


function Header() {
  return (
    <header id="header" className="alt">
      <Logo fill="black" />
    </header>
  )
}

Header.defaultProps = {};
Header.propTypes = {
  onToggleMenu: PropTypes.func.isRequired
};
export default compose(
  translate(),
)(Header);
